var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 272,
    viewBox: "0 0 250 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_1499_7199)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.999,
    y: 2,
    width: 90,
    height: 90,
    rx: 10,
    fill: "#F2B8EC"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.042 42.1028L123.63 31L139.297 42.1028H108.042ZM135.579 52.5303L135.221 50.8833C136.756 51.1706 139.216 54.308 140.012 55.7345C140.418 56.4623 140.774 57.2649 141.064 58.1614C141.645 60.331 141.086 62.3607 138.743 62.8332C137.274 63.1305 134.535 63.1512 132.992 63.0705C131.331 62.9852 128.762 62.9872 128.09 61.2748C127.008 58.5113 128.992 55.2192 130.801 53.2035C131.04 52.9383 131.287 52.6916 131.54 52.463C132.199 51.8818 132.909 51.1912 133.756 50.9046L132.937 52.435L134.126 50.8519H134.752L135.579 52.5303ZM134.814 53.8361V54.2994C135.118 54.332 135.379 54.3947 135.596 54.488C135.815 54.5826 136.004 54.7246 136.166 54.9166C136.294 55.0626 136.393 55.2125 136.463 55.3658C136.533 55.5212 136.568 55.6611 136.568 55.7898C136.568 55.9331 136.515 56.0577 136.412 56.161C136.308 56.265 136.182 56.3177 136.034 56.3177C135.755 56.3177 135.573 56.1657 135.492 55.8631C135.397 55.5065 135.171 55.2685 134.814 55.1512V56.9322C135.166 57.0289 135.448 57.1182 135.656 57.1982C135.865 57.2775 136.053 57.3928 136.218 57.5448C136.393 57.7014 136.53 57.8894 136.626 58.1074C136.721 58.3267 136.768 58.5646 136.768 58.8246C136.768 59.1505 136.693 59.4545 136.541 59.7378C136.387 60.0231 136.164 60.2537 135.868 60.435C135.571 60.615 135.221 60.7216 134.814 60.7549V61.8214C134.814 61.9894 134.797 62.1127 134.764 62.19C134.732 62.2673 134.661 62.3053 134.549 62.3053C134.447 62.3053 134.376 62.2747 134.334 62.212C134.292 62.1487 134.272 62.0507 134.272 61.9194V60.7636C133.941 60.7276 133.65 60.6483 133.401 60.5283C133.152 60.409 132.944 60.2597 132.778 60.081C132.613 59.9017 132.489 59.7158 132.41 59.5245C132.33 59.3318 132.291 59.1419 132.291 58.9559C132.291 58.8206 132.343 58.6959 132.451 58.5866C132.557 58.4773 132.69 58.4213 132.848 58.4213C132.976 58.4213 133.084 58.4507 133.172 58.5106C133.26 58.5706 133.321 58.6553 133.356 58.7633C133.432 58.9972 133.499 59.1772 133.555 59.3012C133.614 59.4252 133.699 59.5391 133.814 59.6418C133.929 59.7438 134.082 59.8224 134.272 59.8771V57.8868C133.891 57.7801 133.574 57.6635 133.318 57.5335C133.062 57.4028 132.854 57.2189 132.696 56.9796C132.537 56.7396 132.457 56.4317 132.457 56.0544C132.457 55.5638 132.613 55.1605 132.924 54.8473C133.235 54.5333 133.685 54.3507 134.272 54.2994V53.8454C134.272 53.6055 134.363 53.4855 134.541 53.4855C134.724 53.4855 134.814 53.6028 134.814 53.8361ZM134.272 56.7736V55.1339C134.034 55.2059 133.848 55.2992 133.714 55.4158C133.58 55.5325 133.513 55.7111 133.513 55.9477C133.513 56.1724 133.576 56.3437 133.7 56.459C133.826 56.575 134.016 56.6796 134.272 56.7736ZM134.814 58.0447V59.9204C135.1 59.8637 135.322 59.7484 135.478 59.5745C135.634 59.3992 135.713 59.1972 135.713 58.9652C135.713 58.7166 135.637 58.5253 135.484 58.3893C135.333 58.2534 135.109 58.138 134.814 58.0447ZM133.257 48.5297C132.986 47.7285 132.742 46.9166 132.537 46.0928C133.304 45.2476 136.269 45.3602 137.121 46.0801L136.332 47.9651C136.757 47.4052 136.9 47.1752 137.153 46.8626C137.259 46.9326 137.36 47.0113 137.454 47.0973C137.678 47.3019 137.879 47.5272 137.92 47.8411C137.946 48.0451 137.887 48.2531 137.707 48.4644L135.895 50.5833C135.663 50.5447 135.434 50.4893 135.213 50.41C135.316 50.1674 135.44 49.9001 135.543 49.6575L134.883 50.3727C134.197 50.2267 133.644 50.3134 133.129 50.5873L131.292 48.3724C131.183 48.2411 131.134 48.1084 131.134 47.9771C131.136 47.4412 131.93 46.9799 132.347 46.8046L133.257 48.5297ZM107.3 58.3047H109.113V56.615H110.064V55.8084H111.087V46.1368H108.996V43.8191H133.376C132.546 43.9778 131.793 44.2937 131.295 44.7863C131.064 45.0084 130.897 45.2878 130.808 45.5962C130.6 45.7335 130.393 45.8935 130.209 46.0708L130.143 46.1368H129.094V52.423C128.056 53.6595 127.017 55.2532 126.446 56.9542C126.104 57.9714 125.927 59.0252 126.001 60.0744H107.3V58.3047ZM136.083 43.8191H138.261V44.6903C137.758 44.2724 136.953 43.9745 136.083 43.8191ZM115.962 56.615H117.142V55.8084H118.165V46.1368H114.939V55.8084H115.962V56.615ZM123.04 56.615H124.222V55.8084H125.243V46.1368H122.016V55.8084H123.04V56.615ZM118.38 39.3026L123.653 35.2393L128.956 39.3026H118.38Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_1499_7199",
    x: -0.000976562,
    y: 0.703704,
    width: 250,
    height: 271.296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.85185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.57407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0168519 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1499_7199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.14815
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25926
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0274815 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1499_7199",
    result: "effect2_dropShadow_1499_7199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1499_7199",
    result: "effect3_dropShadow_1499_7199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 38.5185
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.7407
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0425185 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_1499_7199",
    result: "effect4_dropShadow_1499_7199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 64.8148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 23.4259
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.0531481 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_1499_7199",
    result: "effect5_dropShadow_1499_7199"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.94902 0 0 0 0 0.721569 0 0 0 0 0.92549 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_1499_7199",
    result: "effect6_dropShadow_1499_7199"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_1499_7199",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.d4b6e4cda00ecda858d0e3090c5db9c0.svg";
export { ForwardRef as ReactComponent };